// @flow

import conf from 'client/conf';

const { CONTENTFUL_SPACE_URL } = conf;

export const CARD_ICON_IMAGE_URLS = {
  dental: `${CONTENTFUL_SPACE_URL}/5HdkiF4UWr0mW0lKQqrRla/e16d0f26d1adab0405beff9ec48e6dc5/dental-icon-plan-card.svg`,
  health: `${CONTENTFUL_SPACE_URL}/2Upmp9JntRyuqyCXJebWW/47199e64c40df8353c8498845e3fb2da/doctor-icon.svg`,
  vision: `${CONTENTFUL_SPACE_URL}/7pXVIzgrbKXqAKVAGskTVz/61bf6b49fcd879a5504b425a24d60ad5/vision-icon-plan-card.svg`,
  prescription: `${CONTENTFUL_SPACE_URL}/30hVAWDH6cqHz2JXtaBXI/f5ed44045573c92325c167b7257fa49e/prescription-savings.svg`,
};

export const CROSS_SELL_IMAGE_URLS = {
  dental: `${CONTENTFUL_SPACE_URL}/2reHF0Gq6wkqG4EIkgyMqo/7783c149999f7f643ec375ad29976fa8/dental-small.svg`,
  vision: `${CONTENTFUL_SPACE_URL}/6i1DO4wlry4QmKgcugU6Yi/dec47576697292c5d7f47d7b2d088139/vision-small.svg`,
};
